import React from 'react';
interface LogoProps {
  size?: 'sm' | 'lg';
  className?: string;
}
/**
 * ActiveLink, Inc. wordmark — light gray "Active", navy "Link",
 * with the sunburst mark sitting above the final letter.
 */
export function Logo({
  size = 'sm',
  className = ''
}: LogoProps) {
  const isLarge = size === 'lg';
  const wordSize = isLarge ? 'text-5xl' : 'text-[26px]';
  const incSize = isLarge ? 'text-lg' : 'text-[11px]';
  const sunSize = isLarge ? 'w-7 h-7 -top-4 -right-1' : 'w-4 h-4 -top-2 -right-0.5';
  return <div className={`inline-flex items-end leading-none select-none ${className}`} role="img" aria-label="ActiveLink, Inc." data-id="element-15" data-mp="rs7d6r9kr8gx">
      <span className={`${wordSize} font-normal tracking-tight text-gray-400`} data-id="element-16" data-mp="du90dqawjk3j">
        Active
      </span>
      <span className={`relative ${wordSize} font-bold tracking-tight text-navy-600`} data-id="element-17" data-mp="hvm702ltjrbi">
        Link
        <svg viewBox="0 0 24 24" className={`absolute ${sunSize} text-indigo-400`} fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" aria-hidden="true" data-id="element-18" data-mp="2ykrp3d5v2bil">
          <circle cx="12" cy="12" r="3.25" fill="currentColor" stroke="none" data-id="element-19" data-mp="19x894xviq6re" />
          <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M18.7 5.3l-2.1 2.1M7.4 16.6l-2.1 2.1" data-id="element-20" data-mp="1nvy70fq5wagt" />
        </svg>
      </span>
      <span className={`${incSize} font-medium text-gray-400 ml-1 mb-0.5`} data-id="element-21" data-mp="1jw75bgz3k9xi">
        , Inc.
      </span>
    </div>;
}